import BaseModuleMixin from '../../../mixins/BaseModuleMixin';
import BaseGestaoMixin from '../../../mixins/BaseGestaoMixin';

export default {
    mixins: [
        BaseModuleMixin,
        BaseGestaoMixin,
    ],
    props: {
        moduleId: {
            type: String,
            required: true
        }
    },
    data(){
        return {
            help: {
                active: 'Ativar/desativar o tema',
                visible: 'Colocar o tema visivel (On)',
                private: 'Limita a visualização do tema com base nas permissões atribuídas',
                order: 'Ordem de apresentação',
                legend_automatic: 'Gerar a legenda de forma automática a partir do servidor OGC',
                group: 'Grupo a que pertence',
                placeholderResource: 'Pesquisar Tema...',
                no_abstract: 'No abstract provided',
                resources_title: 'Tema adicionado',
                resources_layers: 'Seleccione o tema pretendido (Apenas 1)',
            },
        }
    },
    computed: {
        moduleInternalCode() {
            return this.moduleId;
        },
    },
}
